import { api } from "@/lib/api";
import type { LoginRequest, User } from "../types";

export const authApi = {
  login: async (credentials: LoginRequest): Promise<void> => {
    await api.post("/auth/login", credentials);
  },

  getMe: async (): Promise<User> => {
    const response = await api.get<User>("/auth/me");
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post("/auth/logout");
  },
};
